<template>
  <framed-layout>

    <template #right>
      <a @click="$router.go(-1)" class="btn-circle cursor-pointer">
        <i class="text-xl text-blue-500 pi pi-times"></i>
      </a>
    </template>

    <div class="max-w-4xl mx-auto">
      <h1 class="text-2xl font-bold leading-tight text-center md:text-4xl lg:text-5xl">
        Unustasid parooli?
      </h1>

      <div class="my-8 md:my-16 max-w-xl mx-auto text-center">
        Sisesta oma e-posti aadress. Saadame sellele aadressile lingi uue parooli sisestamiseks.

        <div class="flex-1 p-float-label py-6">
          <input-text
              id="email"
              placeholder=" "
              v-model="email"
              class="w-full"
              :class="{ 'p-invalid': invalid }"
          />
          <label for="email">Email</label>
        </div>

        <div class="py-6">
          <span>Palun tõmba slider lõpuni</span>

          <div class="py-6">
            <slider v-model="isHumanSlider"
                    @input="isHumanSliderEnds"/>
          </div>
        </div>

        <button
            @click="sendResetPassword"
            :disabled="isNotHuman"
            :class="{ 'opacity-25 pointer-events-none': isNotHuman }"
            class="w-full sm:w-72 text-white bg-blue-500 btn">
          Vaheta parool
        </button>
      </div>


    </div>
  </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout.vue'
import {sendForgotPassword} from "@/store/user.api";
import validEmail from "@/utils/validEmail";

export default {
  components: {
    FramedLayout
  },
  metaInfo: {
    title: 'Unustasid parooli?',
    meta: [
      { property: 'og:title', content: 'Unustasid parooli?' },
      { property: 'robots', content: 'index, nofollow' },
    ]
  },
  data() {
    return {
      email: null,
      invalid: false,
      isNotHuman: true,
      isHumanSlider: 0,
    }
  },
  methods: {
    //If there is an account associated with test@test.com you will receive an email with a link to reset your password.

    isHumanSliderEnds(event) {
      if (event === 100) {
        this.isNotHuman = false;
      } else {
        this.isNotHuman = true;
      }
    },
    async sendResetPassword() {
      if (!validEmail(this.email)) {
        this.invalid = true
      } else {
        const payload = {
          email: this.email
        };
        await sendForgotPassword(payload).then(({data}) => {
          setTimeout(() => {
            this.isNotHuman = true;
            this.isHumanSlider = 0;
            this.processAxiosPositiveResponse(data);
          }, 100);
        });
        this.$router.push('/login');
      }
    }
  }
}
</script>